import React, { Component } from "react";
import { Card, CardBody, CardTitle, CardText, CardImg } from "reactstrap";
import { Container, Row, Col } from "reactstrap";

import { Link } from "react-router-dom";

import "./style.css";

class CourseCards extends Component {
  render() {
    return (
      <div>
        <Container style={{ textAlign: "left" }}>
          <Row>
            <Col
              xs={{ size: 12 }}
              sm={{ size: 6 }}
              lg={{ size: 3 }}
              className="margin-between-cards"
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/web-development-immersive"
              >
                <Card className="m-home-course-cards home-course-cards ">
                  <CardImg
                    className="home-course-card-images m-home-course-card-images"
                    top
                    src="img/full-stack-icon-v2.png"
                    alt="icon"
                  ></CardImg>
                  <CardBody>
                    <CardTitle className="home-course-card-titles m-home-course-card-titles">
                      {this.props.title1}
                    </CardTitle>
                    <CardText className="home-course-card-text m-home-course-card-text  off-white">
                      {this.props.text1}
                    </CardText>
                    <CardText className=" learn-more off-white">
                      Learn More
                    </CardText>
                  </CardBody>
                  <div className="mx-auto ">
                    <div className="view-course-btn m-view-course-btn"></div>
                  </div>
                </Card>
              </Link>
            </Col>

            <Col
              xs={{ size: 12 }}
              sm={{ size: 6 }}
              lg={{ size: 3 }}
              className="margin-between-cards"
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/data-science-immersive"
              >
                <Card className="home-course-cards m-home-course-cards">
                  <CardImg
                    className="home-course-card-images m-home-course-card-images"
                    top
                    src="img/data-science-icon-v2.png"
                    alt="icon"
                  ></CardImg>
                  <CardBody>
                    <CardTitle className="home-course-card-titles m-home-course-card-titles">
                      {this.props.title2}
                    </CardTitle>
                    <CardText className="home-course-card-text m-home-course-card-text off-white">
                      {this.props.text2}
                    </CardText>
                    <CardText className=" learn-more off-white">
                      Learn More
                    </CardText>
                  </CardBody>
                  <div className="mx-auto ">
                    <div className="view-course-btn m-view-course-btn"></div>
                  </div>
                </Card>
              </Link>
            </Col>

            <Col
              xs={{ size: 12 }}
              sm={{ size: 6 }}
              lg={{ size: 3 }}
              className="margin-between-cards"
            >
              <Link style={{ textDecoration: "none" }} to="/digital-marketing">
                <Card className="home-course-cards m-home-course-cards">
                  <CardImg
                    className="home-course-card-images m-home-course-card-images"
                    top
                    src="img/digital-marketing-icon-v2.png"
                    alt="icon"
                  ></CardImg>
                  <CardBody>
                    <CardTitle className="home-course-card-titles m-home-course-card-titles">
                      {this.props.title3}
                    </CardTitle>
                    <CardText className="home-course-card-text m-home-course-card-text  off-white">
                      {this.props.text3}
                    </CardText>
                    <CardText className=" learn-more off-white">
                      Learn More
                    </CardText>
                  </CardBody>

                  <div className="mx-auto ">
                    <div className="view-course-btn m-view-course-btn"></div>
                  </div>
                </Card>
              </Link>
            </Col>

            <Col
              xs={{ size: 12 }}
              sm={{ size: 6 }}
              lg={{ size: 3 }}
              className="margin-between-cards"
            >
              <Link style={{ textDecoration: "none" }} to="/experience-design">
                <Card className="m-home-course-cards home-course-cards">
                  <CardImg
                    className="home-course-card-images m-home-course-card-images"
                    top
                    src="img/exp-design-icon-v2.png"
                    alt="icon"
                  ></CardImg>
                  <CardBody>
                    <CardTitle className="home-course-card-titles m-home-course-card-titles">
                      {this.props.title4}
                    </CardTitle>
                    <CardText className="home-course-card-text m-home-course-card-text  off-white">
                      {this.props.text4}
                    </CardText>
                    <CardText className=" learn-more off-white">
                      Learn More
                    </CardText>
                  </CardBody>

                  <div className="mx-auto ">
                    <div className="view-course-btn m-view-course-btn"></div>
                  </div>
                </Card>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CourseCards;
